import Icon from '../Icon';
import Text from '../Text';

const Technology = ({ icon, name }: { icon: string; name: string }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <Icon icon={icon} fontSize={36} className="text-jb-neutral-500" />
      <Text variant="body-caption" className="text-center text-jb-neutral-500">
        {name}
      </Text>
    </div>
  );
};

export default Technology;
